import type { NotificationCardComponent } from 'src/notifications/cardTypes';
import type { NotificationType } from 'src/notifications/types/Notification';
import DetectionCompleteCard from './components/cards/DetectionCompleteCard';
import DetectionUnreviewedCard from './components/cards/DetectionUnreviewedCard';
import MeetingAgendaCompleteCard from './components/cards/MeetingAgendaCompleteCard';
import MeetingNoteCompleteCard from './components/cards/MeetingNoteCompleteCard';
import MeetingWithoutAgendaCard from './components/cards/MeetingWithoutAgendaCard';
import MeetingWithoutNoteCard from './components/cards/MeetingWithoutNoteCard';
import ProtectionExpiringCard from './components/cards/ProtectionExpiringCard';
import SuitabilityReportCompleteCard from './components/cards/SuitabilityReportCompleteCard';
import SuitabilityReviewDueCard from './components/cards/SuitabilityReviewDueCard';

type NotificationCardEntry<T extends NotificationType> = {
  groupLabel: string;
  component: NotificationCardComponent<T>;
};

export const NOTIFICATION_CARDS: { [T in NotificationType]: NotificationCardEntry<T> } = {
  SUITABILITY_REVIEW_DUE: {
    groupLabel: 'Suitability reviews',
    component: SuitabilityReviewDueCard,
  },
  PROTECTION_EXPIRING: { groupLabel: 'Protection policies', component: ProtectionExpiringCard },
  MEETING_WITHOUT_NOTE: { groupLabel: 'Meetings', component: MeetingWithoutNoteCard },
  MEETING_WITHOUT_AGENDA: { groupLabel: 'Meetings', component: MeetingWithoutAgendaCard },
  DETECTION_UNREVIEWED: { groupLabel: 'Uploads to review', component: DetectionUnreviewedCard },
  UPLOAD_DETECTION_COMPLETE: { groupLabel: 'Uploads', component: DetectionCompleteCard },
  SUITABILITY_REPORT_COMPLETE: {
    groupLabel: 'Suitability reports',
    component: SuitabilityReportCompleteCard,
  },
  MEETING_AGENDA_COMPLETE: { groupLabel: 'Meeting agendas', component: MeetingAgendaCompleteCard },
  MEETING_NOTE_COMPLETE: { groupLabel: 'Meeting notes', component: MeetingNoteCompleteCard },
};

export function notificationGroupLabel(type: NotificationType): string {
  return NOTIFICATION_CARDS[type].groupLabel;
}
